module.exports = __webpack_public_path__ + "static/img/shui1.c1db9d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logistics/shui1.png
// module id = d736
// module chunks = 44